export default __webpack_public_path__ + "static/media/Data-Analytics.33cb4177.png";